module.exports = __webpack_public_path__ + "img/moren-jiabin.2b62a446.jpg";